import get from "lodash.get";

import { isLocal } from "@components/Constants";
import { getConfig } from "@components/Config";

type LinkTemplates = {
  softCommitmentUrl?: string;
};

type Organization = {
  id: string;
  domain: string;
  linkTemplates?: LinkTemplates;
};

type Identity = {
  organization: Organization;
};

const EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS = getConfig(
  "EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS",
) as string[];

const LOCAL_HOST = "http://localhost:3000";

const getProjectScfUrl = (
  identity: Identity,
  projectId: string,
  sponsorId: string,
): string => {
  const { organization } = identity;
  const { domain, id: organizationId } = organization;

  const isExternalInvestorPortalEnabled =
    EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS.includes(organizationId);

  const defaultSoftCommitmentUrl = `https://${domain}`;
  const softCommitmentUrlTemplate = get(
    organization,
    "linkTemplates.softCommitmentUrl",
    defaultSoftCommitmentUrl,
  ) as string;

  const hasSoftCommitmentUrlTemplate =
    softCommitmentUrlTemplate !== defaultSoftCommitmentUrl;

  const shouldUseLinkTemplate =
    isExternalInvestorPortalEnabled && hasSoftCommitmentUrlTemplate;

  if (shouldUseLinkTemplate) {
    return softCommitmentUrlTemplate
      .trim()
      .replace("{projectId}", projectId)
      .replace("{sponsorId}", sponsorId);
  }

  const host = isLocal ? LOCAL_HOST : `https://${domain}`;
  const url = `${host}/scf/create/${projectId}/${sponsorId}`;

  return url;
};

export default getProjectScfUrl;
